import { fetchWithErrorHandling } from '~/lib/util/fe/fetchRoute'

import useAccessGroupsStore, { accessGroupsInitialState } from '.'

export const resetAccessGroupsStore = () => {
  useAccessGroupsStore.setState(accessGroupsInitialState)
}

export const refreshAccessGroups = async (campaignId: number) => {
  const { groups, canSendFullList } = await fetchWithErrorHandling(
    `/api/campaigns/${campaignId}/organizer-access-groups`
  )
  const accessGroups = groups || []
  useAccessGroupsStore.setState({ canSendFullList, accessGroups })
  return {
    canSendFullList,
    accessGroups
  }
}
